/**
 * Badge styling and formatting utilities
 */

export function truncateFirmwareVersion(fwVer, maxLength = 12) {
    if (!fwVer) return '';
    if (fwVer.length <= maxLength) return fwVer;
    return fwVer.substring(0, maxLength) + '...';
}

export function formatTargetName(target) {
    if (!target) return 'Bond';

    const targetMap = {
        'zermatt-2': 'Bridge',
        'zermatt-pro': 'Bridge Pro'
    };

    return targetMap[target] || target;
}
